export enum TableDensityEnum {
  DEFAULT = "middle",
  COMPACT = "small",
  COMFORTABLE = "large",
}
